import { Column, conversionStatusTranslations, FileManagerRow, FMColumn } from '../model';

import { ConversionStatusCellInner } from '../components/cells/ConversionStatusCell';
import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';

import { Type } from '../../../../general/modules/filter/dataModel';
import { WithLoader } from '../components/cells/WithLoader';

export const conversionStatusCol: FMColumn<Type.ID> = {
  key: Column.conversion_status,
  dataKey: Column.conversion_status,
  title: 'Status',
  // 155px — под самую длинную короткую формулировку («Localization error»
  // с иконкой и падингами требует 154px). В макете эта колонка ~90px, но там
  // значения короче наших («OK», «Ready», «Name»): на 90px читается только
  // «OK», а остальные статусы обрезаются многоточием.
  width: 155,
  sortable: true,
  cellRenderer: WithLoader(ConversionStatusCellInner),
  className: 'ch-file-manager__cell_conversion_status',
  filter: Type.ID,
  plugins: [FilterEnumContainer],
  getter: (n: FileManagerRow) => {
    return n.conversionState?.message ?? null;
  },
  toDisplayString: (n: FileManagerRow) => {
    const message = n.conversionState?.message ?? null;
    if (message === null) return null;
    const translations = conversionStatusTranslations[message];
    const messageString = translations !== undefined ? translations.full : `🔡${message}`;
    return messageString;
  },
};
